import React from 'react';
import { BackButton } from '../../features/backButton/backButton';
import { apiConfig } from '../../config/apiConfig';
import { Config } from '../../constants/clientConfig';

interface Props {
  title: string | any;
  children?: any;
  enableBackButton?: boolean;
  enableContentLeftBorder?: boolean;
  enableHeaderExpansion?: boolean;
  childrenClass?: string;
  hideSwapSmartBtn?: boolean;
}

interface State {
  isLogoChanged: boolean;
}

export default class Header extends React.Component<Props, State> {
  static defaultProps: Partial<Props> = {
    children: null,
    childrenClass: '',
    enableBackButton: false,
    enableContentLeftBorder: false,
    enableHeaderExpansion: false,
  };

  constructor(props) {
    super(props);
  }

  onSwapsSmartBtnClick = () => {
    window.open(apiConfig.swapsSmartUrl);
  };

  render() {
    const {
      title,
      children,
      enableBackButton,
      enableContentLeftBorder,
      enableHeaderExpansion,
      childrenClass,
      hideSwapSmartBtn = false,
    } = this.props;
    const showSwapsSmartLinkAsPerConfig = Config.activeConfig.showSwapsSmartLink;

    return (
      <div className="page-header align-items-center">
        <div className="d-flex flex-fill">
          <div className="header-logo">
            <div className="">{Config.activeConfig?.logoWithLabel}</div>
          </div>

          <div className="d-flex align-items-center w-100">
            <div className="d-flex align-items-center">
              {enableBackButton && <BackButton className="ml-18 d-flex cursor-pointer" />}
              <div
                className={`pl-22 text-light-grey header-title ${enableHeaderExpansion ? '' : 'max-w-450px'}`}
                title={title}
              >
                {title}
              </div>
            </div>
            <div className="d-flex align-items-center w-100">
              <div
                className={`w-100 ${enableContentLeftBorder ? 'border-left' : 'd-flex'} ${childrenClass}`}
              >
                {children}
              </div>
              {!hideSwapSmartBtn && showSwapsSmartLinkAsPerConfig && (
                <button
                  className="btn btn-outline-secondary btn-sm mr-10"
                  onClick={this.onSwapsSmartBtnClick}
                >
                  SwapSmart
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
